import { BsHospital } from "react-icons/bs";
import DocumentCategories from "../components/categories/DocumentCategories";
import ChangeLogoPage from "../components/changeLogo/ChangeLogoPage";
import InformationFieldsPage from "../components/informationFields/InformationFieldsPage";
import ClinicSpeciesPage from "../components/species/ClinicSpeciesPage";
import WorkingHoursPage from "../components/workingHours/WorkingHoursPage";
import ClinicView from "../singleView/ClinicView";
import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import ImageIcon from "@mui/icons-material/Image";
import PetsIcon from "@mui/icons-material/Pets";
import ArticleIcon from "@mui/icons-material/Article";
import InventoryIcon from "@mui/icons-material/Inventory";
import ClinicsUsers from "../components/employees/ClinicsUsers";
import { AccountCircle, Apartment } from "@mui/icons-material";
import SettingsIcon from "@mui/icons-material/Settings";
import ClinicOptions from "../components/options/ClinicOptions";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import ClinicWarehousePage from "../components/warehouse/ClinicWarehousePage";
import ClinicBloodDonors from "../components/blooddonors/ClinicBloodDonors";
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import {
  VIEW_CLINIC,
  VIEW_CUSTOM_INFORMATION_FIELD,
  VIEW_DOCUMENT_CATEGORIES,
  VIEW_LOGO_UPLOAD,
  VIEW_WAREHOUSE,
} from "../../../../enums/PermissionTitles";

// `permission` mirrors the matching NAV_BAR_PAGES entry, so master only sees
// the tabs the clinic's own tier grants. General has none on purpose - the
// tier picker lives there, so it must stay reachable even for a clinic
// whose tier grants nothing (e.g. no tier set).

export const tabs = [
  {
    title: "General",
    component: <ClinicView key="clinic-view-key" />,
    icon: <Apartment key="clinic-icon-key" />,
    permission: null,
  },
  {
    title: "Settings",
    component: <ClinicOptions key="clinic-options-key" />,
    icon: <SettingsIcon key="clinic-options-icon-key" />,
    permission: VIEW_CLINIC,
  },
  {
    title: "Employees",
    component: <ClinicsUsers key="employees-view-key" />,
    icon: <AccountCircle key="employees-icon-key" />,
    permission: VIEW_CLINIC,
  },
  {
    title: "WorkingHours",
    component: <WorkingHoursPage key="working-hours-view-key" />,
    icon: <AddHomeWorkIcon key="working-hours-icon-key" />,
    permission: VIEW_CLINIC,
  },
  {
    title: "ChangeLogo",
    component: <ChangeLogoPage key="change-logo-view-key" />,
    icon: <ImageIcon key="change-logo-icon-key" />,
    permission: VIEW_LOGO_UPLOAD,
  },
  {
    title: "Species",
    component: <ClinicSpeciesPage key="species-view-key" />,
    icon: <PetsIcon key="species-icon-key" />,
    permission: VIEW_CLINIC,
  },
  {
    title: "DocumentCategories",
    component: <DocumentCategories key="document-categories-view-key" />,
    icon: <ArticleIcon key="document-categories-icon-key" />,
    permission: VIEW_DOCUMENT_CATEGORIES,
  },
  {
    title: "InformationFields",
    component: <InformationFieldsPage key="information-fields-view-key" />,
    icon: <InventoryIcon key="information-fields-icon-key" />,
    permission: VIEW_CUSTOM_INFORMATION_FIELD,
  },
  {
    title: "BloodDonors",
    component: <ClinicBloodDonors key="blood-donor-view-key" />,
    icon: <BloodtypeIcon key="blood-donor-icon-key" />,
    permission: VIEW_CLINIC,
  },
  {
    title: "Warehouse",
    component: <ClinicWarehousePage key="warehouse-fields-view-key" />,
    icon: <WarehouseIcon key="warehouse-icon-key" />,
    permission: VIEW_WAREHOUSE,
  },
];
